export const SESSION_ID      = `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
export const LOCK_EXPIRY_MS  = 10 * 60 * 1000; // 10 minutes

// Set once by App.js after auth resolves — getSessionName() returns the real
// user display name instead of the device-type fallback.
let _authDisplayName = null;
export const setAuthDisplayName = (name) => { _authDisplayName = name || null; };

export const getSessionName = () =>
  _authDisplayName || (window.innerWidth >= 1024 ? 'Desktop user' : 'Mobile user');

// Returns true if the lock is active (set by a different session and not expired)
export const isLockActive = (lock) => {
  if (!lock?.sessionId || !lock?.at) return false;
  if (lock.sessionId === SESSION_ID) return false;
  return (Date.now() - new Date(lock.at).getTime()) < LOCK_EXPIRY_MS;
};

// Role-aware lock check: returns false (no conflict) if the lock holder has
// different roles to the current user — they write different fields so can
// work simultaneously on the same area.
export const isLockActiveForRoles = (lock, myRoles) => {
  if (!isLockActive(lock)) return false;
  if (lock.roles && myRoles && myRoles.length > 0) {
    const lockRoles = Array.isArray(lock.roles) ? lock.roles : [lock.roles];
    const hasOverlap = lockRoles.some(r => myRoles.includes(r));
    if (!hasOverlap) return false; // different roles — allow simultaneous access
  }
  return true;
};
